import { forwardRef, type Ref, type SVGProps } from "react";

function SvgShiftBoost(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#ShiftBoost_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#ShiftBoost_svg__b)" strokeWidth={20} />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M94.596 45.23c.881-2.708-2.447-4.838-4.37-2.673L75.355 59.293c-1.52 1.71-.364 4.502 1.91 4.502h7.156c.243 0 .436.251.355.517l-3.214 10.504c-.83 2.713 2.504 4.781 4.4 2.61L100.66 60.6c1.498-1.715.339-4.485-1.926-4.485H91.58c-.246 0-.44-.257-.353-.524z"
        />
      </g>
      <rect width={39} height={39} x={28.5} y={10.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={28.5} y={10.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M48 22.636V21m0 16.364V39m3.465-13.91c-.692-.977-1.984-1.636-3.465-1.636h-.444c-1.964 0-3.556 1.303-3.556 2.91v.124c0 1.15.794 2.2 2.05 2.714l3.9 1.596c1.256.514 2.05 1.564 2.05 2.714 0 1.675-1.66 3.033-3.708 3.033H48c-1.48 0-2.773-.658-3.465-1.636"
      />
      <defs>
        <linearGradient
          id="ShiftBoost_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="ShiftBoost_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgShiftBoost);
export default ForwardRef;
